var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEllipsisVSolid = function SvgEllipsisVSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6a1.999 1.999 0 1 0 0 4 1.999 1.999 0 1 0 0-4m0 8a1.999 1.999 0 1 0 0 4 1.999 1.999 0 1 0 0-4m0 8a1.999 1.999 0 1 0 0 4 1.999 1.999 0 1 0 0-4"
  })));
};
export default SvgEllipsisVSolid;